/**
 * Import from node_modules
 */
import 'bootstrap/js/src/scrollspy';

/**
 * Import site scripts
 */
import SkipLinkFocusFix from './site/skip-link-focus-fix';
import Menu from './site/menu';
import Sliders from './site/sliders';
import ScrollTo from './site/scrollTo';
import Styleguide from './site/styleguide';
import Fancybox from './site/fancybox';
import Select2 from './site/select2';
import FormHelpers from './site/formHelpers';
import PerfectScroll from './site/perfectScroll';
import LazyLoading from './site/lazyLoad';
import LoadMoreBlog from './site/loadMoreBlog';
import EqualHeight from './site/equalHeight';
import AOS from 'aos';
import PropertyCards from './site/propertyCards';
import FilterMain from './site/filterMain';
import Login from './site/login';
import PropertySingle from './site/propertySingle';
import AccordionPropertySingle from './site/accordionPropertySingle';
import UploadFile from './site/uploadFile';
import FormValidation from './site/formValidation';
import UploadImage from './site/uploadImage';
import UploadFileEdit from './site/uploadFileEdit';
import DataPicker from './site/dataPicker';
import productPopup from './site/productPreview';
import changeBG from './site/changeBG';

/**
 * Init site scripts
 */
jQuery(function() {
	SkipLinkFocusFix.init();
	Styleguide.init();
	Menu.init();
	ScrollTo.init();
	Fancybox.init();
	Select2.init();
	FormHelpers.init();
	PerfectScroll.init();
	LazyLoading.init();
	LoadMoreBlog.init();
	EqualHeight.init();
	PropertyCards.init();
	FilterMain.init();
	PropertySingle.init();
	AccordionPropertySingle.init();
	UploadFile.init();
	FormValidation.init();
	UploadImage.init();
	UploadFileEdit.init();
	DataPicker.init();
	changeBG.init();
	AOS.init({
		offset: 80,
		duration: 600,
		easing: 'ease-in-sine',
		delay: 100,
		once: true,
		disable: function() {
			const maxWidth = 1200;
			return window.innerWidth < maxWidth;
		}
	});
	Login.init();
	Sliders.init();
	productPopup.init();
});
